type McpChatSuggestionsPreloadProps = {
  cards?: number;
  chips?: number;
};

/** Skeleton for chat welcome «سوالات متداول» while loading from API. */
export function McpChatSuggestionsPreload({
  cards = 4,
  chips = 4
}: McpChatSuggestionsPreloadProps) {
  return (
    <div
      className="flex w-full flex-col gap-2 px-1 placeholder-glow"
      dir="rtl"
      aria-hidden
    >
      <div className="px-0.5">
        <span
          className="placeholder rounded"
          style={{ width: 96, height: 12 }}
        />
      </div>

      <div className="flex w-full gap-1.5 overflow-hidden">
        {Array.from({ length: chips }, (_, index) => (
          <span
            key={index}
            className="placeholder rounded-full flex-shrink-0"
            style={{
              width: index === 0 ? 52 : 88 + (index % 3) * 12,
              height: 28
            }}
          />
        ))}
      </div>

      <div className="grid w-full grid-cols-2 gap-2">
        {Array.from({ length: cards }, (_, index) => (
          <div
            key={index}
            className="border-border/60 flex flex-col gap-2 rounded-xl border px-3 py-2"
          >
            <span
              className="placeholder rounded"
              style={{
                width: index % 2 === 0 ? '92%' : '78%',
                height: 14
              }}
            />
            <span
              className="placeholder rounded"
              style={{ width: '64%', height: 14 }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
